import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  position: relative;
  min-height: calc(100vh - 62px);
  padding-top: 70px;
`;

const HeaderWrapper = styled.div`
  background-color: var(--primary-royal-blue);
  display: grid;
  place-content: center;
`;
const Header = styled.div`
  width: 1200px;
  background-color: var(--primary-royal-blue);
  padding: 56px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media only screen and (max-width: 768px) {
    padding: 30px 0;
  }

  @media only screen and (max-width: 1280px) {
    width: 90vw;
  } ;
`;
const ModuleWrapper = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  gap: 40px;
  &:after {
    background-color: var(--primary-royal-blue);
    content: "";
    top: 0;
    height: 200px;
    width: 100vw;
    position: absolute;
    z-index: -1;
  }
`;

const ModuleContainer = styled.div`
  background-color: #fff;
  border-radius: 24px;
  padding: 40px;
  width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: 70vh;
  overflow: auto;
  box-shadow: 19px 70px 29px rgba(4, 3, 63, 0.01),
    11px 40px 25px rgba(4, 3, 63, 0.03), 5px 18px 18px rgba(4, 3, 63, 0.04),
    1px 4px 10px rgba(4, 3, 63, 0.05), 0px 0px 0px rgba(4, 3, 63, 0.05);
  @media only screen and (max-width: 1280px) {
    width: 90vw;
    padding: 40px 20px;
  }

  @media only screen and (max-width: 768px) {
    overflow-x: hidden;
    padding: 35px;
    margin-bottom: 35px;
  }
`;

const ModuleTitle = styled.p`
  color: var(--neutrals-charcoal);
  font-size: 24px;
  font-weight: 700;
`;

const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const SearchContainerMobile = styled.div`
  width: 80vw;

  @media only screen and (min-width: 769px) {
    display: none;
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 2px;
  background-color: var(--primary-pistachio);
`;
const CategoriesWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
  } ;
`;

const CategoriesContainer = styled.div`
  display: flex;

  p {
    font-size: 14px;
    margin-left: 6px;
    white-space: nowrap;
    cursor: pointer;
    font-weight: 600;
    color: var(--header-text);
  }
  @media only screen and (max-width: 768px) {
    justify-content: flex-start;
    margin: 6px 0;
    width: 300px;

    p {
      margin-left: 10px;
    }
  } ;
`;

const ModuleListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  border-radius: 10px;
  padding: 4px 8px;

  &:hover {
    background-color: #ebf6ff;
  }

  @media only screen and (max-width: 768px) {
    padding: 0;
  }
`;

const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  p {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  @media only screen and (max-width: 768px) {
    font-size: 14px;
    max-width: 180px;
  }
`;

const EmailUser = styled.p`
  color: var(--neutrals-light-gray);
`;

const EditIconContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 40px;
  cursor: pointer;
  align-items: center;
  @media only screen and (max-width: 768px) {
    width: 30px;
    align-items: flex-end;
    svg {
      width: 13px;
    }
  }
`;
const ListDivider = styled.div`
  width: 100%;
  height: 2px;
  background-color: #ebf6ff;
  margin: 1rem 0;
`;
const OpenModalIcon = styled.p`
  cursor: pointer;
`;

const DeleteUserText = styled.p`
  color: var(--neutrals-light-gray);
  margin: 0 0 1.5rem 0;
  text-align:center;
`;
const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const IconListContainer = styled.div`
  border: solid 2px #93c155;
  border-radius: 50%;
  margin-right: 10px;
  padding: 5px;

  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  svg {
    width: 20px;
    height: 20px;
  }
  @media only screen and (max-width: 768px) {
    margin-right: 8px;
    padding: 3px 5px;
    svg {
      width: 18px;
      height: 12px;
    }
  }
`;

const TextNotification = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${({ created }) => (created ? "var(--primary-pistachio)" : "red")};
  margin: 0 20px;
`


export {
  Container,
  Header,
  HeaderWrapper,
  ModuleContainer,
  ModuleListWrapper,
  ListDivider,
  OpenModalIcon,
  EditIconContainer,
  EmailUser,
  UserInfoContainer,
  ItemContainer,
  CategoriesContainer,
  CategoriesWrapper,
  Divider,
  ModuleTitle,
  ModuleWrapper,
  SearchContainer,
  DeleteUserText,
  IconWrapper,
  IconListContainer,
  SearchContainerMobile,
  TextNotification
};
